import { of, map, take, switchMap, catchError, throwError } from 'rxjs';

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthStore } from '@/app/core/store/auth';
import { ProfileService } from '@/app/api/profile';
import { SessionService } from '@/app/core/services/session';

import { ToastService } from '@/app/shared/components/ui/toast';

export const profileResolverGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const toastService = inject(ToastService);
  const profileService = inject(ProfileService);
  const sessionsService = inject(SessionService);

  return authStore.authUser$.pipe(
    take(1),
    switchMap((currentUser) => (currentUser ? of(currentUser) : profileService.getProfileInfo())),
    catchError((error) => {
      toastService.httpError(error);
      sessionsService.navigateToLogin();
      return throwError(() => error);
    }),
    map(() => true),
  );
};
